import { skipToken, useQuery } from '@tanstack/react-query';

import { Workspaces } from '@air/api';
import { type Airror } from '@air/errors';
import { ONE_DAY } from '@air/utilities';
import { callAirApi } from '@air/utils-api';

export const DEFAULT_SETTINGS = 'DEFAULT_SETTINGS';

export type UseGetDefaultSettingsParams = NonNullable<Parameters<typeof Workspaces.ShortUrl.getDefaultSettings>[0]>;
export type ShortUrlDefaultSettingsResponse = Exclude<
  Awaited<ReturnType<typeof Workspaces.ShortUrl.getDefaultSettings>>,
  Airror
>;

export const getDefaultSettingsKey = (params: UseGetDefaultSettingsParams) => [DEFAULT_SETTINGS, params];

export const useGetDefaultSettings = (params: UseGetDefaultSettingsParams, options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: getDefaultSettingsKey(params),
    queryFn: params.workspaceId
      ? () => callAirApi<ShortUrlDefaultSettingsResponse>(() => Workspaces.ShortUrl.getDefaultSettings(params))
      : skipToken,
    enabled: options?.enabled ?? !!params.workspaceId,
    staleTime: ONE_DAY,
  });
